import React, { useRef, useState, useEffect } from 'react';
import Gallery from './Gallery';
import { galleryData } from '../data/galleryData';
import { discoverGalleryPhotos, mergeGalleryPhotos } from '../utils/photoDiscovery';

const Jeep = () => {
  const galleryRef = useRef();
  const [showMore, setShowMore] = useState(false);
  const [photos, setPhotos] = useState(galleryData.jeep || []);

  // Discover additional photos from S3
  useEffect(() => {
    const loadDiscoveredPhotos = async () => {
      try {
        const discoveredPhotos = await discoverGalleryPhotos('jeep');
        const mergedPhotos = mergeGalleryPhotos(galleryData.jeep || [], discoveredPhotos);
        setPhotos(mergedPhotos);
      } catch (error) {
        console.warn('Could not load discovered photos:', error);
        setPhotos(galleryData.jeep || []);
      }
    };

    loadDiscoveredPhotos();
  }, []);

  const handleCelebration = () => {
    setShowMore(!showMore);
  };

  return (
    <section id="jeep" className="section jeep-section">
      <div className="section-header">
        <img src="/images/jeep.png" alt="Jeep" className="section-icon" />
        <h1>Jeep</h1>
      </div>
      <p>
        Adventure awaits with <b>Jeep!</b> Born from military heritage and built for exploration, Jeep represents freedom, capability, and the spirit of adventure.
		My rugged Wrangler can conquer mountain trails, race the waves on the beach, or cruise the city streets. Jeep vehicles are designed to go anywhere and do anything.
      </p>

      {/* Jeep Gallery - Moved to top */}
      <div className="futbol-gallery-section">
        <Gallery 
          ref={galleryRef} 
          images={photos} 
          sectionName="Our Jeep Adventures" 
          thumbnailSize={300}
        />
      </div>

         {showMore && (
          <div className="extended-intro">
            <p>My Jeep Wrangler is a 1995-Jeep-YJ (yes, it has square headlights). I became the proud owner of it in 2015, I won't bore you with all of the history, but if you really want to know you'll need to ask me in person.</p>
			<p>This is where I need to send out some love to all the folks that have been helping me renovate my Jeep. If your a Jeep owner going through the process, you know it's a long & tedious journey, perfect for a Jeep.

			<table align="center" border="0" celspacing="1" cellpadding="1" width="100%">
				<tr>
					<td align="left">
					<strong><u>MVPs</u></strong>
						<li>Dean Ciafraglione</li>
						<li>Fonze Fragola</li>
						<li>Sal Infantio</li>
						<li>Joey Tellerico</li>
						<li>Attilio Volpe</li>
						<br></br>
					<strong><u>Platinum Sponsors</u></strong>
						<li>Fragola Performance Systems</li>
						<li>Jay Sons Screw Machine Products</li>
						<li>Volpe & Son's</li>
						<br></br>
					<strong><u>Gold Sponsors</u></strong>
						<li>Crushtheogre's Used Jeep Parts</li>
						<li>Don Stevens Tire</li>
						<li>Expert Auto Glass</li>
						<li>Perreault's Radiator Shop</li>
						<li>RoBrand</li>
						<li>Shop Supply Services</li>
						<br></br>
					<strong><u>Silver Sponsors</u></strong>
						<li>Advance Auto Parts</li>
						<li>AutoZone</li>
						<li>Eastwood</li>
						<li>Extreme Terrain</li>
						<li>Fraser Engine</li>
						<li>Jegs</li>
						<li>Napa</li>
						<li>Quadratec</li>
						<br></br>
					<strong><u>Honorable Mention</u></strong>
						<li>Home Depot</li>
						<li>Lowe's</li>
						<li>Mad Hatter Muffler</li>
						<li>Southington Power Sports</li>

					</td>
				</tr>
			</table>
			</p>
          </div>
        )}

      <div className="cta-buttons">
        <button className="cta-btn primary" onClick={handleCelebration}>
          <i className="fas fa-car"></i>
          {showMore ? 'Less' : 'My Jeep'}
        </button>
      </div>
    </section>
  );
};

export default Jeep;
